import {ChangeDetectionStrategy, Component, computed, inject, input, output} from '@angular/core';
import {DesignBlockData} from "../../../base-design-block-modal/types/base-design-block.types";
import {defaultDesignBlockData} from "../../../base-design-block-modal/configs/default-design-block-data";
import {ModalsService} from "../../../../../../../../core/services/modals.service";
import {FilesService} from "../../../../../../../../core/services/files.service";
import {ErrorService} from "../../../../../../../../core/services/error.service";
import {BannerSocialFilesStateService} from "../../services/banner-social-files-state.service";
import {BannerSocialShowFileLibraryStateService} from "../../services/banner-social-show-file-library-state.service";
import {BannerSocialFileActionButton} from "../../types/banners-social-modal.types";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {bannersSocialHeaderButtons} from "../../configs/banners-social-header-buttons";

@Component({
  selector: 'div[app-banners-social-header]',
  imports: [
    MatIcon,
    MatIconButton,
    MatTooltip
  ],
  templateUrl: './banners-social-header.component.html',
  styleUrl: './banners-social-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannersSocialHeaderComponent {
  designBlockData = input<DesignBlockData>(defaultDesignBlockData);
  columnKey = input<string>('');
  isActiveUploadFile = input<boolean>(false);
  uploadFiles = output<boolean>();
  handleLoading = output<boolean>();

  private modalService: ModalsService = inject(ModalsService);
  private filesService: FilesService = inject(FilesService);
  private errorService: ErrorService = inject(ErrorService);
  private bannerSocialFilesStateService: BannerSocialFilesStateService = inject(BannerSocialFilesStateService);
  private bannerSocialShowFileLibraryStateService: BannerSocialShowFileLibraryStateService = inject(BannerSocialShowFileLibraryStateService);

  public readonly bannersSocialHeaderButtons = bannersSocialHeaderButtons;
  public isShowFileLibrary = computed(() => this.bannerSocialShowFileLibraryStateService.isShowFileLibrary());

  public getClassBtn(key: BannerSocialFileActionButton): string {
    if (key === 'showFileLibrary' && this.isShowFileLibrary()) {
      return 'header-modal-btn-active';
    }

    if (key === 'upload' && this.isActiveUploadFile()) {
      return 'header-modal-btn-active';
    }

    return '';
  }

  public async handleClick(key: BannerSocialFileActionButton): Promise<void> {
    const actionMap = {
      history: () => this.openHistoryModal(),
      upload: () => this.handelUpload(),
      download: () => this.openDownloadModal(),
      showFileLibrary: () => this.handelShowFileLibrary()
    } as const;

    await actionMap[key]?.();
  }

  private async openHistoryModal(): Promise<void> {
    this.modalService.openHistoryChangesModal({
      historyChangesData: this.designBlockData().history,
      columnKey: this.columnKey()
    });
  }

  private handelUpload() {
    if (this.bannerSocialFilesStateService.bannerSocialFilesState().length >= 99) {
      this.errorService.showErrorMessage('Максимальное количество файлов достигнуто. Удалите лишние файлы, чтобы освободить место для новых.');
      return;
    }

    this.uploadFiles.emit(!this.isActiveUploadFile());
  }

  private async openDownloadModal(): Promise<void> {
    const fileIds = this.bannerSocialFilesStateService.bannerSocialFileIds();
    this.handleLoading.emit(true);
    await this.filesService.downloadArchiveFiles(fileIds)
      .finally(() => this.handleLoading.emit(false));
  }

  private handelShowFileLibrary(): void {
    this.bannerSocialShowFileLibraryStateService.toggleShowFileLibrary();
  }
}
